import RandingStyle31 from "../../randing/RandingStyle31";

const footerText = `시술 및 수술 결과는 개인별 상태에 따라 달라질 수 있으며,
환자의 구강ㆍ치아 조건에 따라 치료 방법과 비용이 달라질 수 있습니다.

Copyright ⓒ 퍼널스 · (주)빅크래프트

사업자등록번호 127-88-03197 · 402-88-02065`;

function Randing523({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle31
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/523`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/389/03.gif`}
      companyName="본원"
      privacyCompanyName="더봄치과의원"
      privacyNewForm={true}
      footerText={footerText}
      footerLegalColor="#5a5a5a"
      privacyTrustee="(주)퍼널스,(주)빅크래프트"
      themeColor="#009493"
      areaQuestion="현재 거주하시는 지역을 선택해주세요."
      areaOptions={[
        { label: "춘천", value: "춘천" },
        { label: "화천", value: "화천" },
        { label: "홍천", value: "홍천" },
        { label: "철원", value: "철원" },
        { label: "인제", value: "인제" },
        { label: "양구", value: "양구" },
      ]}
      // serviceInfoText="본 서비스는 당사와 제휴된 전국 30여개 병,의원에서 제공되며, 상담 신청 정보를 기반으로 적합한 제휴 병,의원을 안내해드립니다."
      imageAltTexts={{ header: "춘천 임플란트 혜택", sub: "설문 참여 이미지" }}
    />
  );
}

export default Randing523;
